import SecureLS from "secure-ls";
import GlobalApi from "./GlobalApi";
import Configs from "../constants/Configs";
import { API_CODE_SUCCESS } from "../constants/CommonConstant";
import watermarkImageHeight from "../../src/assets/image/warterMarkerHeight.png?v=10";
import watermarkImageWidth from "../../src/assets/image/waterMark2.png?v=10";
import { loadImage } from "canvas";
import crypto from "crypto-js";
import { isEmpty } from "lodash";
import {
  CRSDeclareLocationKey,
  CRSUnSaveRadioCheck,
  Master,
} from "./GlobalKey";
// import { deviceDetect } from "react-device-detect";
import {
  browserName,
  osName,
  mobileVendor,
  mobileModel,
  deviceType,
  getUA,
} from "react-device-detect";
import moment from "moment";
import "moment/locale/en-gb"; // บาง environment ต้องโหลด locale ด้วย;
// const head_token = getData("HeaderManp")
//   ? getData("HeaderManp")?.head_token
//   : "";
// const device = deviceDetect();
import qs from "qs";
const header = {
  headers: {
    Accept: "application/json",
  },
};
const ls = new SecureLS({
  encodingType: process.env.REACT_APP_ENCODE_TYPE,
  isCompression: false,
  encryptionSecret: process.env.REACT_APP_SECRET_CODE,
});
const head_token = getData("HeaderManp")
  ? getData("HeaderManp")?.head_token
  : "";

export function storeData(name, object) {
  return ls.set(name, object);
}

export function getData(name) {
  try {
    return ls.get(name);
  } catch (error) {
    console.log("error =", error);
  }
}

export function getDataOTP(name) {
  try {
    return ls.get(name);
  } catch (error) {
    serviceLogs(name, error?.message || error, error, "getDataOTP");
    console.log("error =", error);
  }
}
export async function clearData(key) {
  return await ls.remove(key);
}
export async function getAllStorage(stamp_page) {
  // console.log("localStorage > >", Object.keys(localStorage))
  // console.log("ls >> ", ls.getAllKeys())
  var values = [],
    // keys = Object.keys(localStorage),
    keys = ls.getAllKeys(),
    i = keys.length;
  var keys_dont_save = [
    "_secure__ls__metadata",
    "lang",
    "api_error",
    "Translations",
    "comebackWithOtp",
    "registerRequestData",
    "aecode",
    "editPage",
    "currentStep",
    "back_from_ats_apply",
    "back_from_ats",
    "back_from_idc",
    "back_form_otp",
    "lastExternalReferrer",
    "lastExternalReferrerTime",
    Master.countryList,
    CRSDeclareLocationKey,
    CRSUnSaveRadioCheck,
  ];
  try {
    while (i--) {
      // console.log(`i: ${i}`);
      // console.log(`key: ${keys[i]}, value: ${localStorage.getItem("keys[i]")}`);

      if (!keys_dont_save.includes(keys[i])) {
        // console.log(`key: ${keys[i]}`);
        if (keys[i] === "stamp_page") {
          // console.log(`key: ${keys[i]},value: ${stamp_page}`);
          values.push({
            key: keys[i],
            value: stamp_page,
          });
        } else if (keys[i] === "HeaderManp") {
          // console.log(`key: ${keys[i]},value: ${getData(keys[i])}`);
          values.push({
            key: keys[i],
            value: {
              head_token: getData(keys[i]).head_token,
              token: getData(keys[i]).token,
            },
          });
        } else {
          // console.log(`key: ${keys[i]},value: ${getData(keys[i])}`);
          values.push({
            key: keys[i],
            value: getData(keys[i]),
          });
        }
      }
    }
    return values;
  } catch (error) {
    console.log(error);
  }
}
export async function getAllStorageOTP(stamp_page) {
  // console.log("localStorage > >", Object.keys(localStorage))
  // console.log("ls >> ", ls.getAllKeys())

  var values = [],
    // keys = Object.keys(localStorage),
    keys = ls.getAllKeys(),
    i = keys.length;
  var keys_dont_save = [
    "_secure__ls__metadata",
    "lang",
    "api_error",
    "Translations",
    "comebackWithOtp",
    "registerRequestData",
    "aecode",
    "editPage",
    "currentStep",
    "back_from_ats_apply",
    "back_from_ats",
    "back_from_idc",
    "back_form_otp",
    "lastExternalReferrer",
    "lastExternalReferrerTime",
    Master.countryList,
    CRSDeclareLocationKey,
    CRSUnSaveRadioCheck,
  ];
  try {
    while (i--) {
      if (!keys_dont_save.includes(keys[i])) {
        // console.log(`key: ${keys[i]}`);
        if (keys[i] === "stamp_page") {
          // console.log(`key: ${keys[i]},value: ${stamp_page}`);
          values.push({
            key: keys[i],
            value: stamp_page,
          });
        } else if (keys[i] === "HeaderManp") {
          // console.log(`key: ${keys[i]},value: ${getData(keys[i])}`);
          values.push({
            key: keys[i],
            value: {
              head_token: getData(keys[i]).head_token,
              token: getData(keys[i]).token,
            },
          });
        } else {
          values.push({
            key: keys[i],
            value: getDataOTP(keys[i]),
          });
        }
      }
    }
    return values;
  } catch (error) {
    console.log(error);
    serviceLogs(
      `key: ${keys[i]}`,
      error?.message || error,
      error,
      "getAllStorageOTP",
    );
    return error;
  }
}
export async function getUserdata(last_stamp) {
  last_stamp = await JSON.parse(last_stamp);
  if (last_stamp !== null && last_stamp.length > 0) {
    var i = last_stamp.length;
    while (i--) {
      if (last_stamp[i].key !== "checkuserinfo") {
        if (last_stamp[i].key !== "stamp_page") {
        }
      }
    }
    const stamp_page = getData("stamp_page") ? getData("stamp_page") : "";
  }
}
export async function checkEditPage() {
  var str = window.location.href;
  let re = /edit/;
  const back_to_edit = re.test(str);
  return back_to_edit;
}
export async function callChoice(head_token) {
  let data = [];
  const header = {
    headers: {
      Accept: "application/json",
    },
  };
  try {
    await GlobalApi.post(
      `${Configs.baseAPIURL03}/form/product/selbyhead`,
      { head_token: head_token },
      header,
    )
      .then((res) => {
        if (res.status === API_CODE_SUCCESS) {
          data = res?.data?.Data;
        }
      })
      .catch((er) => {});
  } catch (error) {}
  return data;
}
export async function serviceLogs(api, data, status, step) {
  try {
    const idc = (await getData("checkuserinfo").cardId)
      ? getData("checkuserinfo").cardId
      : "";
    const device = {
      Browser: browserName,
      OS: osName,
      DeviceType: deviceType || "Desktop",
      MobileVendor: mobileVendor || "N/A",
      MobileModel: mobileModel || "N/A",
    };
    const postData = {
      card_id: idc,
      api: api,
      step: step,
      data: JSON.stringify(data),
      device: JSON.stringify(device),
      apistatus: JSON.stringify(status),
    };
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    await GlobalApi.post(
      `${Configs.baseAPIURL03}/form/comeback/debug_web`,
      postData,
      header,
    );
  } catch (error) {
    console.log(error);
  }
}
export async function checkDipChipStatus(head_token, data) {
  const saveData = [
    {
      name: "dipchip_status",
      url: `${Configs.baseAPIURL03}/form/dipchip_status/selbyhead`,
      postData: {
        head_token: head_token,
        id_card: data?.id_card,
        ae_code: data?.aecode,
      },
    },
  ];
  try {
    await GlobalApi.post(saveData[0].url, saveData[0].postData, header)
      .then(async (res) => {
        if (res?.data?.Data?.[0]?.IsSuccess === 1) {
          const dipchipData = res?.data?.Data?.[0].Data?.[0];
          await saveDipchip(dipchipData, head_token, data);
        }
      })
      .catch((err) => {
        throw err;
      });
  } catch (error) {
    throw error;
  }
}

export async function checkGtokenAccount(idCard, aeCode) {
  const body = { id_card: idCard };
  try {
    const res = await GlobalApi.post(
      `${Configs.baseAPIURL03}/form/current_gtoken/selbyidentity`,
      body,
      { headers: { "Content-Type": "application/json" } },
    );
    const isEmp = res?.data.MsgData?.is_employee;
    const isCMKT = res?.data.MsgData?.MktData?.ic_data.some(
      (item) => item.ic_central_aecode === aeCode?.toUpperCase(),
    );
    const gtokenMsg =
      (!isEmp && res?.data.IsSuccess) ||
      (isEmp && isCMKT) ||
      (isEmp && !aeCode);
    return gtokenMsg;
  } catch (error) {
    throw error;
  }
}
export async function saveDipchip(dipchipData, head_token, data) {
  try {
    const complete_date = moment(
      dipchipData.SAfdp_CompleteDate?.date,
      "YYYY-MM-DD HH:mm:ss.SSSSSS",
    );
    const saveData = [
      {
        name: "dipchip_status",
        url: `${Configs.baseAPIURL03}/form/dipchip/manp`,
        postData: {
          head_token: head_token,
          id_card: data?.id_card,
          ae_code: data?.aecode,
          firstname: dipchipData.SAfdp_FirstName,
          lastname: dipchipData.SAfdp_LastName,
          middlename: dipchipData.SAfdp_MiddleName,
          birthday: dipchipData.SAfdp_Birthday,
          respose_code: dipchipData.SAfdp_ResposeCode,
          respose_desc: dipchipData.SAfdp_ResposeDesc,
          is_error: dipchipData.SAfdp_IsError,
          complete_date: complete_date.format("YYYY-MM-DD HH:mm:ss.SSS"),
          channel: "OA",
          mkt_remark: dipchipData.SAfdp_MKTRemark,
          doc_ref1: dipchipData.SAfdp_Doc_ref1,
          doc_ref2: dipchipData.SAfdp_Doc_ref2,
        },
      },
    ];
    await GlobalApi.post(saveData[0].url, saveData[0].postData, header)
      .then(async (res) => {
        if (res?.data?.Data?.[0]?.IsSuccess === 1) {
          storeData("pass_dipchip", true);
          var stamp_page = getData("stamp_page");
          if (stamp_page === "SUMMARY") {
            saveComeback("CONFIRM", head_token);
          }
        } else {
          storeData("pass_dipchip", false);
        }
      })
      .catch((err) => {
        throw err;
      });
  } catch (error) {
    throw error;
  }
}
export async function saveComeback(type, head_token) {
  storeData("stamp_page", type);
  var last_stamp = JSON.stringify(await getAllStorage(type));
  const saveData = [
    {
      name: "comeback",
      url: `${Configs.baseAPIURL03}/form/comeback/manp`,
      postData: {
        head_token: head_token,
        last_stamp: last_stamp,
        stamp_page: type,
      },
    },
  ];
  try {
    await GlobalApi.post(saveData[0].url, qs.stringify(saveData[0].postData), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },
    })
      .then((res) => {
        if (res?.data?.Data?.[0]?.[0]?.IsSuccess === 1) {
          // type === "EKYC" ? storeData("pass_dipchip", false) : type === "CONFIRM" ? storeData("pass_dipchip", true) : "";
        }
      })
      .catch((er) => {
        throw er;
      });
  } catch (error) {
    throw error;
  }
}
async function getSize(base64) {
  const upload = new Image();
  upload.src = base64;
  return upload;
}
export async function addWarterMarker(base64, check, hash) {
  const canvas = await document.createElement("canvas");
  const ctx = await canvas.getContext("2d");
  const upload = await getSize(base64);
  let data = "";
  let imgMark = "";
  const Upload = getData("openSizeUploadImage");
  const sizeUpload = getData("sizeUploadImage");
  const checkWidth = Upload ? sizeUpload?.width : await upload.width;
  const checkHeight = Upload ? sizeUpload?.height : await upload.height;
  if (checkWidth > checkHeight) {
    imgMark = watermarkImageWidth;
  } else if (checkWidth < checkHeight) {
    imgMark = watermarkImageHeight;
  } else {
    imgMark = watermarkImageWidth;
  }
  await loadImage(imgMark)
    .then(async (img) => {
      const maxW = 1200;
      const maxH = 1200;
      const iw = await img.width;
      const ih = await img.height;
      const scale = Math.min(maxW / iw, maxH / ih);
      const iwScaled = iw * scale;
      const ihScaled = ih * scale;
      canvas.width = iwScaled;
      canvas.height = ihScaled;
      ctx.fillStyle = "rgb(255, 255, 255)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      if (check && !isEmpty(hash) && !isEmpty(base64)) {
        if (!checkHashImage(base64, hash)) return;
      }
      ctx.drawImage(upload, 0, 0, iwScaled, ihScaled);
      ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
      data = canvas.toDataURL("image/jpeg", 0.5);
    })
    .catch((e) => {
      return;
    });
  return await data;
}
export function setHash(image) {
  if (!isEmpty(image)) {
    return crypto.SHA256(image).toString();
  }
  return;
}
export function checkHashImage(image, hash) {
  const hashData = setHash(image);
  if (!isEmpty(hashData) && !isEmpty(hash) && hashData === hash) {
    return true;
  }
  return false;
}

export async function getAllCountry() {
  let data = [];

  const header = {
    headers: {
      Accept: "application/json",
    },
  };

  try {
    const countryListMaster = getData(Master.countryList);
    if (!isEmpty(countryListMaster)) {
      return countryListMaster;
    }

    const url = `${Configs.baseAPIURL03}/constant/country`;
    await GlobalApi.get(url, header)
      .then((res) => {
        data = res.data.Data;
        console.log(res.data);
        storeData(Master.countryList, data);
      })
      .catch((err) => {
        throw err;
      });
  } catch (error) {
    if (process.env.REACT_APP_ENVIRONMENT === "local") {
      console.log("error getAllCountry: ", error);
    }
  }

  return data;
}
const normalizeTitle = (str) => {
  return str?.replace(/\./g, "").trim().toLowerCase();
};
export const findTitleByEn = (titleEn, titleData) => {
  const normalizedInput = normalizeTitle(titleEn);
  return (
    titleData.find((item) => normalizeTitle(item.NameEN) === normalizedInput) ||
    null
  );
};
export function convertToDate(dateStr) {
  if (!dateStr) return null;

  const nonDateValues = ["LIFELONG", "N/A", "-"]; // เพิ่มค่าอื่นๆ ที่เป็นไปได้
  if (nonDateValues.includes(dateStr.toUpperCase().trim())) {
    return null;
  }

  let newDate = toDate(dateStr);
  const parsed = moment(newDate);

  if (!parsed.isValid()) {
    return null;
  }

  return parsed.format("YYYYMMDD");
}
const toDate = (date) => {
  const inputDate = date.replace(".", "").trim(); // ลบจุดจากเดือน
  const [day, monthStr, year] = inputDate.split(" ");

  // สร้าง mapping เดือน
  const monthMap = {
    Jan: 0,
    Feb: 1,
    Mar: 2,
    Apr: 3,
    May: 4,
    Jun: 5,
    Jul: 6,
    Aug: 7,
    Sep: 8,
    Oct: 9,
    Nov: 10,
    Dec: 11,
  };

  const month = monthMap[monthStr];

  if (month === undefined) {
    console.error("Invalid month:", monthStr);
    return null; // ✅ คืนค่า null ถ้าเดือนผิด
  }

  return new Date(Number(year), month, Number(day)); // ✅ แปลง day/year เป็นตัวเลข
};
